<div class="container">
  <button
    *ngFor="let variant of variants"
    class="btn"
    [ngClass]="{
      'red': active === variant,
      'transparent': active !== variant
    }"
    type="button"
    (click)="handleChoose(variant)"
  >
    {{ variant }}
    <svg *ngIf="active === variant" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.091 0.242142C11.3253 0.476457 11.3253 0.856356 11.091 1.09067L4.42433 7.75734C4.19001 7.99165 3.81012 7.99165 3.5758 7.75734L0.909134 5.09067C0.67482 4.85636 0.67482 4.47646 0.909134 4.24214C1.14345 4.00783 1.52335 4.00783 1.75766 4.24214L4.00006 6.48454L10.2425 0.242142C10.4768 0.0078276 10.8567 0.0078276 11.091 0.242142Z" fill="white" />
    </svg>
  </button>
</div> 